module.exports = __webpack_public_path__ + "static/media/aviso-covid.6c9b6993.jpg";